<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-right">
        <ul>
          <li>
            <a href="https://www.focus.org" target="_blank" rel="noopener">FOCUS Main Site</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {};

</script>
<style>

</style>
